export const cutLongStrings = (description: string, maxCaracter = 20) =>
description.length > maxCaracter ? description.slice(0, maxCaracter) + "..." : description;
